export default "__VITE_ASSET__8a0a4746__"